import React, { useContext } from "react";

import { gameContext } from "../contexts/game";

export const withGameContext = (Component) => (props) => {
    const context = useContext<GameContext>(gameContext);

    return <Component {...props} context={context} />;
};
